import ResourcesModule from '../../../resources/resources';
import template from './settingsGameDevEdit.jade';
import Services from '../../../services/services';

export class AccountSettingsGameDevEditController {
  /* @ngInject */
  constructor(currentUser, GameDevelopersResource, notify) {
    this.notify = notify;

    currentUser.subscribe(user => {
        if (!_.isEmpty(user.game_developer_ids)) {
          GameDevelopersResource.one(user.game_developer_ids[0]).get()
            .then(gameDeveloper => {
              this.gameDeveloper = gameDeveloper;
            })
        }
    })
  }

  save() {
    this.gameDeveloper.save()
      .then(() => {
        this.notify.updated('gameDeveloper', this.gameDeveloper.company_name);
      })
      .catch(this.notify.apiError);
  }
}

export function AccountSettingsGameDevEditComponent() {
  return {
    template,
    controller: AccountSettingsGameDevEditController,
    restrict: 'E',
    controllerAs: 'vm',
    scope: {},
    bindToController: true
  };
};

export default angular.module('app.components.account.settings.gameDevEdit', [
  ResourcesModule.name,
  Services.name
])
.directive('accountSettingsGameDevEdit', AccountSettingsGameDevEditComponent);



/** WEBPACK FOOTER **
 ** ./src/components/account/settings/settingsGameDevEdit.js
 **/